import React, { useState, useEffect } from "react";
import ArticleItem from "./ArticleItem";
import { Modal, Button, Form } from "react-bootstrap";
import Paginate from "../../common/Paginate";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import articlesService from "../../../services/articles.service";
import { toast } from "react-toastify";
function ArticlesList({
                        articlesList = [],
                        itemsPerPage = 5,
                        currentPage = 1,
                        totalPages,
                        paginate,
                        pageNumbers = [],
                        headingText = "Latest Articles",
                      }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [customMessage, setCustomMessage] = useState(
      "Here is an interesting article for you to read."
  );

  const todaysAppointment = useEyeconxStore((state) => state.todaysAppointment);
  const user = useEyeconxStore((state) => state.user);
  const [selectedPatient, setSelectedPatient] = useState(null);

  useEffect(() => {
    setCheckedItems(articlesList.map(() => false));
  }, [articlesList]);


  const handleCheckboxChange = (e, article, index) => {
    const updatedChecked = [...checkedItems];
    updatedChecked[index] = e.target.checked;
    setCheckedItems(updatedChecked);

    if (e.target.checked) {
      setSelectedArticle((prev) => [...prev, article.id]);
    } else {
      setSelectedArticle((prev) => prev.filter((id) => id !== article.id));
    }
  };

  const handleClearSelected = () => {
    setCheckedItems(articlesList.map(() => false));
    setSelectedArticle([]);
  };

  const handleSelectedPatient = (patient) => {
    setSelectedPatient(patient);
  };

  const sendArticleToPatient = () => {
    const data = {
      mediumType: "EMAIL",
      articleIds: selectedArticle,
      patientId: selectedPatient.patientId,
      customMessage,
    };

    articlesService
        .sendArticleToPatient(user.clinicId, data)
        .then(() => {
          toast.success("Articles sent successfully");
          setShowModal(false);
          handleClearSelected();
        })
        .catch(() => {
          toast.error("Error sending articles");
        });
  };

  return (
      <>
          {/* Header with spacing */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 mt-6 p-4">
              {/* Heading */}
              <h2 className="d-flex align-items-center mb-3 mb-md-0">
                  <i className="bi bi-newspaper me-2"></i>
                  {headingText}
              </h2>

              {/* Buttons + Pagination */}
              <div className="d-flex flex-column flex-md-row align-items-center gap-2">
                  {selectedArticle.length > 0 && (
                      <div className="d-flex gap-2  mb-md-0">
                          <button
                              type="button"
                              className="btn btn-primary d-flex align-items-center text-white"
                              onClick={() => setShowModal(true)}
                          >
                              <i className="bi bi-send me-1"></i>
                              Send Selected ({selectedArticle.length})
                          </button>

                          <button
                              type="button"
                              className="btn btn-outline-secondary  d-flex align-items-center"
                              onClick={handleClearSelected}
                          >
                              <i className="bi bi-x-circle me-1"></i>
                              Clear
                          </button>
                      </div>
                  )}

                  {/* Pagination */}
                  <div>

                  </div>
              </div>
          </div>





          {/* Article Items */}
        <div className="mt-3">
          {articlesList.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <i className="bi bi-inbox fs-1 mb-2 d-block"></i>
                <p className="mb-0">No articles found</p>
              </div>
          ) : (
              articlesList.map((article, index) => (
                  <ArticleItem
                      key={article.id}
                      chindex={index}
                      article={article}
                      handleCheckboxChange={handleCheckboxChange}
                      checkedItem={checkedItems[index]}
                  />
              ))
          )}
        </div>

        <Paginate
            position="center"
            totalPages={totalPages}
            currentPage={currentPage}
            paginate={paginate}
            pageNumbers={pageNumbers}
        />

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="bi bi-person-lines-fill me-2"></i> Send Articles to Patient
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {/* Left: Patients */}
              <div className="col-md-6 border-end">
                <h6 className="mb-3 fw-semibold">Today's Appointments</h6>
                {todaysAppointment?.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {todaysAppointment.map((p, i) => (
                          <span
                              key={i}
                              className={`badge bg-${selectedPatient?.patientId === p.patientId ? "primary" : "secondary"} text-white p-2`}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSelectedPatient(p)}
                          >
                      {p.firstName} {p.lastName}
                    </span>
                      ))}
                    </div>
                ) : (
                    <p className="text-muted">No patients found</p>
                )}
              </div>

              {/* Right: Message */}
              <div className="col-md-6 mt-4 mt-md-0">
                <Form.Group>
                  <Form.Label>Custom Message</Form.Label>
                  <Form.Control
                      as="textarea"
                      rows={4}
                      value={customMessage}
                      onChange={(e) => setCustomMessage(e.target.value)}
                  />
                </Form.Group>

                {selectedPatient && selectedArticle.length > 0 && (
                    <div className="mt-3">
                      <p className="fw-semibold">
                        Sending <strong>{selectedArticle.length}</strong>{" "}
                        {selectedArticle.length > 1 ? "articles" : "article"} to{" "}
                        <span className="text-primary">
                      {selectedPatient.firstName} {selectedPatient.lastName}
                    </span>
                      </p>
                      <Button variant="success" onClick={sendArticleToPatient}>
                        <i className="bi bi-send me-1"></i> Send
                      </Button>
                    </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </>
  );
}

export default ArticlesList;
